export function downloadMassiveImportReport (response, filename = 'respuesta_error.txt') {
  const textContent = response
    .map(item => `Mensaje: ${item.message}\nError: ${item.error}\n`)
    .join('\n')

  const blob = new Blob([textContent], { type: 'text/plain' })
  const blobUrl = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = blobUrl
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(blobUrl)
}
